/**
 * A shallow copy of `obj` with `keys` left out.
 *
 * The usual way to spell an omit is `const { key: _ignored, ...rest } = obj`, but
 * that leaves the dropped key in the file as an unused binding — which the lint
 * gate reports (`@typescript-eslint/no-unused-vars`, card t_e2507c3b). Naming the
 * keys instead keeps the intent readable and the gate clean.
 */
export function omitKeys<T extends object>(obj: T, keys: readonly string[]): T {
  const copy: Record<string, unknown> = { ...(obj as Record<string, unknown>) };
  for (const key of keys) delete copy[String(key)];
  return copy as T;
}
